import CONFIG from '../api/config';

const enabled = CONFIG.RENDER_DEBUG_ON && !CONFIG.IS_PRODUCTION;

const stats = {};

export default {
    log: (...params) => {
        if (enabled) {
            // eslint-disable-next-line
            console.log('LOGGER:', ...params);
        }
    },
    trace: (...params) => {
        // eslint-disable-next-line
        console.warn('TRACE:', ...params);
    },
    warn: (...params) => {
        // eslint-disable-next-line
        console.warn('WARN:', ...params);
    },
    error: (...params) => {
        // eslint-disable-next-line
        console.error('ERROR:', ...params);
    },
    table: (...params) => {
        if (enabled) {
            // eslint-disable-next-line
            console.table('LOGGER', ...params);
        }
    },
    render: key => {
        if (enabled) {
            if (stats[key]) {
                stats[key]++;
            } else {
                stats[key] = 1;
            }
            // eslint-disable-next-line
            console.log('RENDER: ', key);
        }
    }
};

let theWindow = {};

if (typeof window !== 'undefined') {
    theWindow = window;
}

theWindow.stats = stats;



// WEBPACK FOOTER //
// ./src/lib/debug.js